<style scoped>
.str0 {
    stroke: #F58634;
    stroke-width: 7.52;
    stroke-miterlimit: 4
}

.fil0 {
    fill: none;
    fill-rule: nonzero
}
</style>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="7.2934mm" height="6.2104mm" version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 155.55 132.45" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">

        <g id="Camada_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer" />
            <path class="fil0 str0"
                d="M77.77 128.69c-0.72,0 -1.44,-0.21 -2.05,-0.64 -46.67,-32.27 -71.96,-55.04 -71.96,-82.92 0,-23.19 17.05,-41.36 38.82,-41.36 19.29,0 30.19,12.81 35.19,21.01 5.01,-8.19 15.92,-21.01 35.2,-21.01 21.76,0 38.82,18.17 38.82,41.36 0,27.89 -25.29,50.65 -71.95,82.92 -0.62,0.44 -1.34,0.64 -2.06,0.64z" />
        </g>
    </svg>
</template>